export default __webpack_public_path__ + "2cdf204d39925e0c9077c3bdc8cf34ba.png";